import { ACTION, SET_GLOBAL } from "Redux/actionTypes";

export interface GlobalState {
    pace: number;
    currentTick: number;
    tickTime: number;
    paused: boolean;
    focusedMessage: number | null;
    menuOpen: boolean;
    descriptionsVisible: boolean;
    runSeed: number;
}

const initialState: GlobalState = {
    pace: 3,
    currentTick: 0,
    tickTime: 0,
    paused: false,
    focusedMessage: null,
    menuOpen: true,
    descriptionsVisible: true,
    runSeed: Date.now(),
};

export default function reduce(state = initialState, action: ACTION) {
    switch (action.type) {
        case SET_GLOBAL: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
}
